export { };

declare global {
    interface Date {
        addDays(days: number): Date;
        isToday(): boolean;
        clone(): Date;
        isAnotherMonth(date: Date): boolean;
        isWeekend(): boolean;
        isSameDate(date: Date): boolean;
        getStringDate(): String;
        getFirstDayOfMonth(): Date;
        getFirstDayOfWeek(): Date;
        getMidnight(): Date;
        isEarlier(date: Date, canSameDate?: boolean, checkOnlyDate?: boolean): boolean;
        isLater(date: Date, canSameDate?: boolean, checkOnlyDate?: boolean): boolean;
    }

    interface StringConstructor {
        format: (text: string, ...args: any[]) => string;
    }

    interface Array<T extends number> {
        sum(): number;
    }
}

declare module '@angular/forms' {
    interface AbstractControl {
        warnings?: string;
    }

    interface FormControl {
        warnings?: string;
    }
}

Date.prototype.addDays = function (days: number): Date {
    if (!days) return this;
    let date = this.clone();
    date.setDate(date.getDate() + days);

    return date;
};

Date.prototype.isToday = function (): boolean {
    let today = new Date();
    return this.isSameDate(today);
};

Date.prototype.clone = function (): Date {
    return new Date(+this);
};

Date.prototype.isAnotherMonth = function (date: Date): boolean {
    return date && this.getMonth() !== date.getMonth();
};

Date.prototype.isWeekend = function (): boolean {
    return this.getDay() === 0 || this.getDay() === 6;
};

Date.prototype.isSameDate = function (date: Date): boolean {
    return (
        date &&
        this.getFullYear() === date.getFullYear() &&
        this.getMonth() === date.getMonth() &&
        this.getDate() === date.getDate()
    );
};

Date.prototype.getStringDate = function (): String {
    //Month names in English
    let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let today = new Date();
    if (this.getMonth() == today.getMonth() && this.getDay() == today.getDay()) {
        return "Today";
    } else if (
        this.getMonth() == today.getMonth() &&
        this.getDay() == today.getDay() + 1
    ) {
        return "Tomorrow";
    } else if (
        this.getMonth() == today.getMonth() &&
        this.getDay() == today.getDay() - 1
    ) {
        return "Yesterday";
    } else {
        return monthNames[this.getMonth()] + ' ' + this.getDay() + ', ' +  this.getFullYear();
    }
};


Date.prototype.getFirstDayOfMonth = function (): Date {
    return new Date(this.getFullYear(), this.getMonth(), 1);
}
Date.prototype.getFirstDayOfWeek = function (): Date {
    const day = this.getDay(); // 0: vasárnap, 1: hétfő, ..., 6: szombat
    const diff = (day === 0 ? 6 : day - 1); // Hétfőre számítunk
    const firstDay = new Date(this); // Új Date példány a jelenlegi dátummal
    firstDay.setDate(this.getDate() - diff); // Előző hétfő
    firstDay.setHours(0, 0, 0, 0); // Beállítjuk a dátumot 00:00-ra
    return firstDay;
}

Date.prototype.getMidnight = function (): Date {
    var date = this.clone();
    date.setHours(0,0,0,0);
    return date;
}

Date.prototype.isEarlier = function (date: Date, canSameDate: boolean = true, checkOnlyDate: boolean = false): boolean {
    if(canSameDate && checkOnlyDate && this.isSameDate(date)) return true;
    return checkOnlyDate
        ? this.getMidnight().getTime() < date.getMidnight().getTime()
        : this.getTime() < date.getTime()
}

Date.prototype.isLater = function (date: Date, canSameDate: boolean = true, checkOnlyDate: boolean = false): boolean {
    if(canSameDate && checkOnlyDate && this.isSameDate(date)) return true;
    return checkOnlyDate
        ? this.getMidnight().getTime() >= date.getMidnight().addDays(1).getTime()
        : this.getTime() > date.getTime();
}


String.format = function (text: string, ...args: any[]): string {
    return text.replace(/{(\d+)}/g, (match, index) =>
        typeof args[index] !== 'undefined' ? args[index] : match
    );
};

Array.prototype.sum = function () {
    if (this.some((element) => !(element instanceof Number)))
        throw new Error('A tömb tartalmaz nem szám elemeket');
    return this.reduce((acc: number, curr: number) => acc + curr, 0);
};
